module.exports = __webpack_public_path__ + "static/media/youtube-shadow.fcdb40b7.png";